<script lang="ts" setup>
import { QIcon } from 'quasar'
import { computed } from 'vue'
import { Color, ColorSemantic } from '@previo/codebooks'

interface Props {
  icon: string
  color?: Color | ColorSemantic
  size?: number
  cursorPointer?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 16,
  cursorPointer: false,
})
const BRAND_PREFIX: string = 'brand'

const isIconOfBrand = computed<boolean>(() => {
  const regex = new RegExp('^' + BRAND_PREFIX + '\\s')

  return regex.test(props.icon)
})

const style = computed<string>(() => {
  return isIconOfBrand.value ? 'brands' : 'light'
})

const iconName = computed<string>(() => {
  if (isIconOfBrand.value) {
    // Remove "BRAND_PREFIX" and space between string (Ex: 'brand gitlab' => `gitlab`)
    return props.icon.replace(BRAND_PREFIX, '').trim()
  }

  return props.icon
})
</script>

<template>
  <q-icon
    :color="color"
    :name="`fa-${style} fa-${iconName}`"
    :size="`${size}px`"
    :class="[{ 'ds-icon': true, 'p-cursor-pointer': cursorPointer }]"
  />
</template>

<style lang="scss" scoped>
.ds-icon {
  padding: 4px;
}
</style>
